import { useAppTranslation } from "@/utils";
import { Button, Col, Drawer, Flex, Grid, Page, Row, Typography } from "@payping/web-components";
import { Close, Login } from "@payping/icons";
import { DashboardRoutes } from "@/router";
import { Link, useNavigate } from "react-router-dom";
import { SubLayout } from "@/components/SubLayout";
import { closeId, haveAccountId, noAccountId } from "@/assets/googleTrackIds";

const AccountConnectionForm = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const { md } = Grid.useBreakpoint();
  return (
    <>
      <Drawer
        title={t("digitalAccount.samanBankAccountConnectionForm.title")}
        open={true}
        closeIcon={false}
        placement={"bottom"}
        height={"100%"}
        extra={
          <Button
            type={"text"}
            icon={<Close width={14} height={14} />}
            onClick={() => {
              navigate(DashboardRoutes.digitalAccount.home?.url);
            }}
            data-google-track={closeId}
          />
        }
      >
        <Page>
          <SubLayout>
            <div className="!tw-flex !tw-justify-center">
              <Flex vertical gap={"large"}>
                <div className="!tw-flex !tw-justify-center">
                  <Login width={84} />
                </div>
                <Typography.Title level={4} className="tw-mb-0 !tw-flex !tw-justify-center">
                  {t("digitalAccount.samanBankAccountConnectionForm.doYouHaveSamanBankAccount")}
                </Typography.Title>
                <Flex vertical gap={"small"} className="!tw-flex !tw-items-center">
                  <Typography.Text type={"secondary"}>
                    {t("digitalAccount.samanBankAccountConnectionForm.bankAccountConditions")}
                  </Typography.Text>
                  <Typography.Text>
                    {t("digitalAccount.samanBankAccountConnectionForm.activeAccountLegal")}
                  </Typography.Text>
                  <Typography.Text>
                    {t("digitalAccount.samanBankAccountConnectionForm.noDebtInSamanBank")}
                  </Typography.Text>
                  <Typography.Text>
                    {t("digitalAccount.samanBankAccountConnectionForm.noNeedToUseInternetBankAccount")}
                  </Typography.Text>
                </Flex>
                {md ? (
                  <Flex gap={8} className="!tw-flex !tw-justify-center">
                    <Link to={DashboardRoutes.digitalAccount.saman.getAccessAccount.url}>
                      <Button type={"primary"} data-google-track={haveAccountId}>
                        {t("digitalAccount.samanBankAccountConnectionForm.yes,I have")}
                      </Button>
                    </Link>
                    <Link to={DashboardRoutes.digitalAccount.saman.newAccount.offline.url}>
                      <Button type={"default"} data-google-track={noAccountId}>
                        {t("digitalAccount.samanBankAccountConnectionForm.no,helpOpening")}
                      </Button>
                    </Link>
                  </Flex>
                ) : null}
              </Flex>
            </div>
          </SubLayout>
        </Page>
      </Drawer>
      {!md ? (
        <Drawer open={true} mask={false} closable={false} placement={"bottom"} height={80}>
          <Row gutter={[8, 8]}>
            <Col flex={3}>
              <Link to={DashboardRoutes.digitalAccount.saman.getAccessAccount.url}>
                <Button block type={"primary"} data-google-track={haveAccountId}>
                  {t("digitalAccount.samanBankAccountConnectionForm.yes,I have")}
                </Button>
              </Link>
            </Col>
            <Col flex={1}>
              <Link to={DashboardRoutes.digitalAccount.saman.newAccount.offline.url}>
                <Button block type={"default"} data-google-track={noAccountId}>
                  {t("digitalAccount.samanBankAccountConnectionForm.no,helpOpening")}
                </Button>
              </Link>
            </Col>
          </Row>
        </Drawer>
      ) : null}
    </>
  );
};

export default AccountConnectionForm;
